import { render, staticRenderFns } from "./AccountingDocView.vue?vue&type=template&id=4e05e108&scoped=true&"
import script from "./AccountingDocView.vue?vue&type=script&lang=js&"
export * from "./AccountingDocView.vue?vue&type=script&lang=js&"
import style0 from "./AccountingDocView.vue?vue&type=style&index=0&id=4e05e108&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e05e108",
  null
  
)

export default component.exports